import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material/tabs';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { QuestionResponseCorrectionDialogComponent } from '../question-response-correction-dialog/question-response-correction-dialog.component';
import { UserProcessListQuestionDialogComponent } from '../user-process-list-question-dialog/user-process-list-question-dialog.component';
import { OneSignalService } from 'src/services/onesignal.service';
import { SelectionTestDialogComponent } from '../selection-test-dialog/selection-test-dialog.component';

@Component({
  selector: 'app-process-list-selection-test-dialog',
  templateUrl: './process-list-selection-test-dialog.component.html',
  styleUrls: ['./process-list-selection-test-dialog.component.scss']
})
export class ProcessListSelectionTestDialogComponent implements OnInit {

  tests: Array<any>;
  candidateId: number = null;
  processListId: number = null;
  @ViewChild('selectionTestList', { static: false }) selectionTestList: MatSelectionList;
  submiting: boolean = false;
  processListTest: Array<any> = [];
  showResponses: boolean = false;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  private currentUser: any;
  processList: any;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<ProcessListSelectionTestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private oneSignalService: OneSignalService,
  ) { 
    if(data) {
      this.candidateId = parseInt(data.candidateId);
      this.processListId = parseInt(data.processListId);
      this.processList = data.processList;
      //this.showResponses = data.showResponses
    }
  }

  ngOnInit(): void {
    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;          
        if(scope.indexOf('process_list') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)
    this.currentUser = JSON.parse(localStorage.getItem('token'));
    this.getSelectionTest();
    this.getProcessListTest();   
  }

  getProcessListTest() {

    const data = {
      processList: this.processListId,
      userId: this.candidateId
    };
    
    this.http.list('user_process_list:test', data)
      .subscribe(
        (result: any) => {
          this.processListTest = result.data;
        },
        err => this.errorReport.showMessage(err)
      )
      
  }

  getSelectionTest() {

    const params = {
      companyId: this.currentUser.company_id
    }

    this.http.list('selection_test', params)
      .subscribe(
        (tests: any) => {
          this.tests = tests
          this.onChangeViewForAll();
          setTimeout(() => this.tabGroup.selectedIndex = 0, 100)
        },
        err => this.errorReport.showMessage(err)
      )
    
  }

  saveProcessList() {

    const tests = this.selectionTestList.selectedOptions.selected.map(selected => selected.value);
    const data = {
      tests,
      processList: this.processListId,
      candidates: [ this.candidateId ]
    }
    
    this.http.save('process_list:test', data)
      .subscribe(
        () => {

          this.http.save('onsignal:getUser', {leads: { lead_ids: [this.candidateId] }})
            .subscribe(
              (result: any) => {
                if (result.type === 'OK') {
                  const signatureIds = result.data.map((item: any) => item.signature_id); // Extrai os signature_ids
                  //console.log('assinaturas', signatureIds);
                  const notification_for_all = null;
                  const title = 'Novo Teste';
                  const fullname = null;
                  
                  // Mapear o nome dos testes correspondentes aos IDs selecionados
                  const testNames = tests.map((testId: any) => {
                    const matchingTest = this.tests.find((item: any) => item.id === testId);
                    return matchingTest ? matchingTest.name : null; // Retorna o nome se encontrado, caso contrário, null
                  });
                  
                  // Converte o array de nomes em uma única string separada por vírgulas
                  const testNamesString = testNames.filter(name => name !== null).join(', ');

                  const message = this.oneSignalService.listMessage(7, fullname, this.processList.name, testNamesString );
                  
                  // Envia os dados para a função do backend que lida com as notificações
                  this.oneSignalService.sendNotification(signatureIds, title, message, notification_for_all)
                  .subscribe(
                    (result: any) => {
                      if (result.type === 'OK') {
                        this.oneSignalService.listNotification();
                      } else {
                        console.error('Erro ao enviar notificação para o candidato sobre o teste');
                      }
                    },
                    err => {
                      console.error('Erro ao enviar notificação ao candidato novo teste', err);
                      this.errorReport.showMessage(err);
                    }
                  );
                } else {
                  console.error('Erro ao obter dados para o envio da notificação');
                }
              },
              err => this.errorReport.showMessage(err)
            )

          this.snackbar.open('Teste adicionado com sucesso ao candidato!', 'OK', { duration: 3000 });
          this.dialogRef.close();
        },
        err => this.errorReport.showMessage(err)
      )

    this.http.save('process_list_action', {
      processList: this.processListId,
      action: 'test',
      leads: [ this.candidateId ]
    })
      .subscribe({
        error: err => this.errorReport.showMessage(err)
      });

  }

  hasProcessListTestSelected(test) {

    if(this.processListTest.length === 0)
      return false;
    
    return this.processListTest.findIndex(_test => _test.id == test.id) > -1;    

  }

  hasProcessListTestPending(test) {

    if(this.processListTest.length === 0)
      return false;
    
    return this.processListTest.findIndex(_test => {
      return _test.id == test.id && _test.status !== 'pending'
    }) > -1;

  }

  disableSaveTest() {

    return this.processListTest.length === this.selectionTestList.selectedOptions.selected.length;

  }

  openQuestions(test) {

    if(test.status === 'pending') {
      this.snackbar.open('Esse questionário ainda não foi respondido', 'OK', { duration: 3000 });
      return;
    }
    
    const options = {
      width: '800px',
      disableClose: true,
      data: { 
        test,
        userId: this.candidateId,
        processListId: this.processListId
      } 
    }
    this.dialog.open(UserProcessListQuestionDialogComponent, options)
  }

  openQuestionResponseCorrection(test) {    

    const options = {
      width: '800px',
      disableClose: true,
      data: { 
        test,
        userId: this.candidateId,
        processList: this.processListId,
        ProcessListName: this.processList
      } 
    }
    this.dialog.open(QuestionResponseCorrectionDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if(result)
            this.getProcessListTest()
        }
      )

  }

  onChangeViewForAll() {
    if (this.tests && this.tests.length > 0) {
      const testIds = this.tests.map((test: any) => test.id);
  
      const params = {
        userId: this.candidateId,
        testIds: JSON.stringify(testIds), // Enviar array de IDs
        processId: this.processListId,
        view: 1
      };
  
      this.http.save('user_process_list:test_views', params)
        .subscribe(
          (result: any) => {
          },
          err => this.errorReport.showMessage(err)
        );
    }
  }

  openNewTest() {

    const options = {
      disableClose: true,
      width: '800px',
      data: {}
    }
    this.dialog.open(SelectionTestDialogComponent, options)
    .afterClosed()
      .subscribe(
        result => {
          if(result)
            this.getSelectionTest();
            this.getProcessListTest();
        }
      )

  }

}
